import React from "react";
import { Radio } from "antd";
import { RadioChangeEvent } from "antd/es/radio";
import { OptionItem, RadioEventProps } from "../../../../../../Service";

interface Props extends RadioEventProps {
    options: OptionItem[];
}
const Index = ({ onChange, value, options, onSave, ...restProps }: Props) => {
    function Change(e: RadioChangeEvent) {
        onChange?.(e.target.value);
        onSave(e.target.value);
    }
    return (
        <>
            <Radio.Group {...restProps} onChange={Change} value={value}>
                {options.map(item => (
                    <Radio key={item.id} value={item.id}>
                        {item.description}
                    </Radio>
                ))}
            </Radio.Group>
        </>
    );
};

export default Index;
